import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../../../../../components/ui/modal-form-container/modal-form-container.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IEntitySegmentQuery } from '../../../../../../components/organization/segments/segment-utilities';

@Component({
  selector: 'message-selected-segments',
  standalone: true,
  imports: [ModalFormContainerComponent, MatTooltipModule],
  templateUrl: './message-selected-segments.component.html',
  styleUrls: ['./message-selected-segments.component.css', '../selected-list.css'],
})
export class MessageSelectedSegmentsComponent {
  constructor() {}

  @Input() open: boolean = false;
  @Output() close = new EventEmitter();
  @Input() selectedSegments: IEntitySegmentQuery[] = [];
  @Output() removeSegment = new EventEmitter<IEntitySegmentQuery>();

  handleRemoveSegment(item: IEntitySegmentQuery) {
    this.removeSegment.emit(item);
  }

  closeModal() {
    this.close.emit();
  }
}
